import Alert, { POP_OUT_DURATION } from './Alert';
import { DEFAULT_BOTTOM } from './Alert.jss';

export default Alert;

export { POP_OUT_DURATION, DEFAULT_BOTTOM };
